import { List, fromJS } from 'immutable';

export function request(state, { userId, legUid, data }) {
    let legs = state.get('legs');
    let userLegs = legs.get(userId);

    if (userLegs.get(legUid)) {
        userLegs = userLegs.set(legUid, userLegs.get(legUid).merge(fromJS(data)));
    }

    return state
        .set('legs', legs.set(userId, userLegs));
}

export function bulkUpdate( state, { userId, stake } ) {
    const legs = state.getIn( [ 'bets', userId ], List() ).map( leg => {
        if (leg.get('type') === 'SGL') {
            return leg.set( 'stakePerLine', stake || 0 );
        }
        return leg;
    });
    return state.setIn( [ 'bets', userId ], legs );
}
